export default 'M17 7.5 22 0H2v22c0 1.1.9 2 2 2s2-.9 2-2v-7h16l-5-7.5z';